import { Allow, IsArray, IsEnum, IsInt, IsOptional, IsString, IsUUID } from "class-validator";
import { Transform } from "class-transformer";
import type { Moment } from "moment";

import { transformMoment } from "../helpers/transforms";
import { IsMoment, IsOptionalString } from "../helpers/decorators";
import {
  type CourseRegistrationState,
  courseRegistrationStates,
  type LocaleType,
  locales,
  paymentCompanies,
  type PaymentCompany,
} from "../types";

import { User } from "./user";

export class CourseRegistration {
  @Allow()
  user: User;

  @IsUUID()
  courseRegistrationId: string;
  @IsInt()
  variableSymbol: number;
  @IsEnum(paymentCompanies)
  company: PaymentCompany;
  @IsString()
  productId: string;
  @IsOptional()
  @IsString()
  termId?: string;
  @IsEnum(locales)
  locale: LocaleType;
  @IsOptionalString()
  @IsString()
  preferredTime?: string;
  @IsOptionalString()
  @IsString()
  preferredDay?: string;
  @IsOptional()
  @IsString()
  faculty?: string;
  @IsOptionalString()
  @IsString()
  variation?: string;
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  subjects?: string[];
  @IsOptionalString()
  @IsString()
  paymentFrequency?: string;
  @Transform(transformMoment)
  @IsMoment()
  timestamp: Moment;
  @IsEnum(courseRegistrationStates)
  state: CourseRegistrationState;
}
